import { render, staticRenderFns } from "./LastYearsProjects.vue?vue&type=template&id=26eec4dc&"
import script from "./LastYearsProjects.vue?vue&type=script&lang=ts&"
export * from "./LastYearsProjects.vue?vue&type=script&lang=ts&"
import style0 from "./LastYearsProjects.vue?vue&type=style&index=0&id=26eec4dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports